import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Facebook, Instagram, Phone } from 'lucide-react';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  const navLinks = [
    { path: '/', label: 'Accueil' },
    { path: '/aides-personne', label: 'Aides à la personne' },
    { path: '/garde-enfant', label: 'Garde d\'enfant' },
    { path: '/menage', label: 'Ménage' },
    { path: '/bricolage', label: 'Bricolage' },
    { path: '/informatique', label: 'Informatique' },
    { path: '/contact', label: 'Contact' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Scrolled state for background change
      setIsScrolled(currentScrollY > 50);
      
      if (currentScrollY < 10) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else if (currentScrollY < lastScrollY) {
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const isActive = (path) => location.pathname === path;

  const headerClasses = `network-header ${isVisible ? 'header-visible' : 'header-hidden'} ${isScrolled ? 'scrolled' : ''}`;

  return (
    <header className={headerClasses}>
      <div className="nav-wrapper">
        <Link to="/" className="network-logo">
          <img 
            src="/images/logo.jpg" 
            alt="Réseau d'Aide à Domicile" 
            className="logo-image"
          />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="network-nav desktop-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`network-nav-link ${isActive(link.path) ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <a href="tel:0481119591" className="header-cta">
          <Phone size={16} />
          <span>04 81 11 95 91</span>
        </a>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="mobile-nav">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`mobile-nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          
          {/* Phone CTA for Mobile */}
          <a href="tel:0481119591" className="mobile-cta" onClick={() => setIsMenuOpen(false)}>
            <Phone size={20} />
            <span>04 81 11 95 91</span>
          </a>
          
          {/* Social Links for Mobile */}
          <div className="mobile-nav-social">
            <div className="mobile-social-links">
              <a 
                href="https://www.facebook.com/reseaudaideadomicile/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mobile-social-link"
                onClick={() => setIsMenuOpen(false)}
              >
                <Facebook size={22} />
              </a>
              <a 
                href="https://www.instagram.com/reseaudaideadomicile/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="mobile-social-link"
                onClick={() => setIsMenuOpen(false)}
              >
                <Instagram size={22} />
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};